document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarTiempoMuerto') {
        
        const botonActivo = e.submitter;
        if (!botonActivo || botonActivo.id !== 'btnEditarTiempoMuertoInyeccion') {
            return;
        }

        e.preventDefault();
        
        const formulario = e.target;
        const modalPadre = formulario.closest('.modal');
        const spinner = formulario.querySelector('#spinner');
        const btnEditar = formulario.querySelector('#btnEditarTiempoMuertoInyeccion'); // Localizamos dentro del form
        
        const formData = new FormData(formulario, botonActivo);

        btnEditar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));

        try {
            const respuesta = await fetch('/api/inyeccion/editar-tiempo-muerto', {
                method: 'POST',
                body: formData
            });

            const json = await respuesta.json();
            const status = respuesta.status;
            const resultado = json.result;
            

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud, contacta al Administrador.");
                window.location.href = "/inyeccion";
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
            } else {
                // ÉXITO
                const idReporteInput = formulario.querySelector('#idEncabezadoReporteInyeccion');
                const idReporte = idReporteInput ? idReporteInput.value : null;
                
                const params = new URLSearchParams(window.location.search);
                const mes = params.get("mes");
                const año = params.get("año");

                if (modalPadre) modalPadre.classList.remove('modal--show');
                
                lanzarAlerta("Registro editado con éxito.", "alerta-verde");
                
                // Actualizar vistas sin recargar
                if (typeof window.actualizarModalReporteInyeccion === 'function' && idReporte) {
                    window.actualizarModalReporteInyeccion(idReporte);
                }
                
                if (typeof window.actualizarTableroInyeccionPeriodo === 'function') {
                    window.actualizarTableroInyeccionPeriodo(mes, año);
                    window.actualizarTablaInyeccionPeriodo(mes, año);
                }
                if (typeof window.actualizarZonaTrabajo === 'function') {
                    if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
                }
            }

        } catch (error) {
            console.error("Error:", error);
            alert("Error crítico al procesar la solicitud, contactar al Administrador.");
            window.location.href = "/inyeccion";
        } finally {
            if (btnEditar) btnEditar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    }
});